export default {
    computed: {
        isYandex() {
            return window.report_db.engine === "yandex";
        },
        isGoogle() {
            return window.report_db.engine === "google";
        },
        reportEngine() {
            return window.report_db.engine;
        },
        isGoogleGny() {
            return window.report_db.engine === 'google' && window.report_db.name === 'gny';
        }
    }
}
